<template>
<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
  <g data-name="menu" transform="translate(-669.707 -149.915)">
    <rect width="22" height="2" rx="1" transform="rotate(-45 542.052 -728.968)" fill="currentColor"/>
    <rect width="22" height="2" rx="1" transform="rotate(45 151.155 892.883)" fill="currentColor"/>
  </g>
  <path fill="none" d="M0 0h26v26H0z"/>
</svg>
</template>
